var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.vehicle)?_c('LiveTrackingVehiclePolyline',{attrs:{"vehicle":_vm.vehicle,"motion-line-data":_vm.motionLineData}}):_vm._e(),(_vm.shouldDrawPath)?_vm._l((_vm.paths),function(path,i){return _c('LiveTrackingNextStopPolyline',{key:`directions-${i}`,attrs:{"vehicle":_vm.vehicle,"path":path}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }